import React from 'react';
import { Badge, Button } from 'react-bootstrap';
import { formatAppTime } from '../../../utils/appTimezone';
import { ReceptionStatusBadge } from '../ui';
import {
  canRegisterRdvVisit,
  formatRdvServiceLabel,
  formatRdvSlotDay,
  rdvRowClassName
} from '../rdvFormatters';

export default function RendezVousListRows({ rows, onRegisterVisit, onViewDetail }) {
  return rows.map((r) => {
    const patientName =
      `${r.member_prenom || r.external_prenom || ''} ${r.member_nom || r.external_nom || ''}`.trim() ||
      '—';
    const canRegister = canRegisterRdvVisit(r);
    const motif = String(r.motif || '').trim();

    return (
      <article
        key={r.id}
        className={`${rdvRowClassName(r)} recv-rdv-row--clickable`}
        role="listitem"
        tabIndex={0}
        onClick={() => onViewDetail?.(r)}
        onKeyDown={(ev) => {
          if (ev.key === 'Enter' || ev.key === ' ') {
            ev.preventDefault();
            onViewDetail?.(r);
          }
        }}
      >
        <div className="recv-rdv-row__slot recv-rdv-list__cell recv-rdv-list__cell--slot">
          <span className="recv-rdv-row__date">{formatRdvSlotDay(r.start_at)}</span>
          <span className="recv-rdv-row__hour font-monospace">{formatAppTime(r.start_at)}</span>
          <span className="recv-rdv-row__ref font-monospace" title={r.reference}>
            {r.reference || '—'}
          </span>
        </div>
        <div className="recv-rdv-row__patient recv-rdv-list__cell recv-rdv-list__cell--patient">
          <div className="recv-rdv-row__name" title={patientName}>
            {patientName}
          </div>
          {motif ? (
            <div className="recv-rdv-row__motif" title={motif}>
              {motif}
            </div>
          ) : null}
        </div>
        <div className="recv-rdv-row__type recv-rdv-list__cell recv-rdv-list__cell--type">
          <ReceptionStatusBadge kind="rdvType" value={r.type_rendez_vous || 'AUTRE_SERVICE'} />
        </div>
        <div className="recv-rdv-row__service recv-rdv-list__cell recv-rdv-list__cell--service">
          <span className="recv-rdv-row__service-label">Service</span>
          <span className="recv-rdv-row__service-value">{formatRdvServiceLabel(r.service)}</span>
        </div>
        <div className="recv-rdv-row__status recv-rdv-list__cell recv-rdv-list__cell--status">
          <span className="recv-rdv-row__status-label">Statut</span>
          <div className="recv-rdv-row__badges">
            <ReceptionStatusBadge kind="rdvStatus" value={r.status || 'EN_ATTENTE'} />
            {String(r.priority || '').toUpperCase() === 'URGENT' ? (
              <ReceptionStatusBadge kind="priority" value="URGENT" />
            ) : null}
          </div>
        </div>
        <div className="recv-rdv-row__action recv-rdv-list__cell recv-rdv-list__cell--action">
          <div className="recv-rdv-row__actions">
            <Button
              size="sm"
              variant="outline-secondary"
              className="recv-rdv-row__detail-btn"
              onClick={(ev) => {
                ev.stopPropagation();
                onViewDetail?.(r);
              }}
            >
              Détail
            </Button>
            {r.reception_visit_id ? (
              <Badge bg="success" className="recv-rdv-row__visit-badge">
                Visite #{r.reception_visit_id}
              </Badge>
            ) : canRegister ? (
              <Button
                size="sm"
                variant="outline-primary"
                className="recv-rdv-row__register-btn"
                onClick={(ev) => {
                  ev.stopPropagation();
                  onRegisterVisit(r);
                }}
              >
                Enregistrer visite
              </Button>
            ) : (
              <span className="recv-rdv-row__closed-label">Non disponible</span>
            )}
          </div>
        </div>
      </article>
    );
  });
}
